import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';
import { fontWeight } from 'src/assets/fonts-config';

export const BannerTitle = styled('div', { label: 'BannerTitle' })`
    font-size: 14px;
    font-weight: ${fontWeight.bold};
    color: ${mainColors.main.primary};
`;

export const BannerImage = styled('img', { label: 'BannerImage' })`
    display: block;
    margin-bottom: 12px;
    width: 100%;
`;
